import React from "react";
import { addDays, format } from "date-fns";
interface WeekHeaderProps {
  weekDates: Date[];
  columnWidth: number;
}

const WeekHeader: React.FC<WeekHeaderProps> = ({ weekDates, columnWidth }) => {
  return (
    <div className="flex text-[10px] text-center text-gray-500">
      {weekDates.map((start, i) => {
        const end = addDays(start, 6);
        const startMonth = format(start, "MMM");
        const endMonth = format(end, "MMM");

        const sharedWeek = startMonth !== endMonth;
        const label = `${format(start, "d")} – ${format(end, "d")}`;

        return (
          <div
            key={i}
            className={`py-1 flex items-center justify-center ${
              i % 2 === 0 ? "bg-gray-100" : "bg-gray-200"
            }`}
            style={{
              width: `${columnWidth}px`,
              borderRight: "1px solid white",
              ...(sharedWeek ? { borderRight: "none" } : {}),
            }}
          >
            {label}
          </div>
        );
      })}
    </div>
  );
};

export default WeekHeader;
